import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: 'https://anoopam.com/aims/api/',
    timeout: 1000,
    // headers: { 'X-Custom-Header': 'foobar' }
});